import {
  LightMode,
  ThermostatAuto,
  WaterDrop,
  Opacity,
  FlashOn,
  Battery4Bar,
  Bloodtype,
  Grain,
} from "@mui/icons-material";
import { ReactComponent as PM2_5 } from "../assets/icons/pm2-5.svg";
import { ReactComponent as PM10 } from "../assets/icons/pm10.svg";
import { ReactComponent as Water_temp } from "../assets/icons/water_temp.svg";
import { SvgIcon } from "@mui/material";
const getIcon = (type) => {
  return (
    {
      lightIntensity: <LightMode />,
      airTemperature: <ThermostatAuto />,
      relativeHumidity: <WaterDrop />,
      waterLevel: <Bloodtype />,
      soilwater: <Opacity />,
      pm10: (
        <SvgIcon>
          <PM10 />
        </SvgIcon>
      ),
      "pm2.5": (
        <SvgIcon>
          <PM2_5 />
        </SvgIcon>
      ),
      outsideVoltage: <FlashOn />,
      battery: <Battery4Bar />,
      tds: <Grain />,
      temp: (
        <SvgIcon>
          <Water_temp />
        </SvgIcon>
      ),
    }[type] ?? <>{type}</>
  );
};

export default getIcon;
